import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Replace with your deployed Apps Script API link
const API_URL = 'https://script.googleusercontent.com/a/macros/rosotravel.com/echo?user_content_key=AehSKLi0RlC_bBbJvku8L34FLTuR-EtH4kvWIEeMDvI_D-R4_S2IosLQX_mnpng30z_1cAAG9HRiPggKzOTB0VnF827vE2VZbemJJ9LHX1ERGkq36SAV8xUd86tquiLdVSOUrw2kh-rj6gjYCrEPDY7Q2BM9xSWlEABRTwbzai9o9wiyyJLXUHb82osCr3xxXjbvkgUWgMmtxkKzYeZDllGeorN9j-VGnslxS_T7V7r1T1HgEHExXLvNqmMSKjvc7sBUFX_uRo5bwCn1iv-iNPeCtj7fANPFibtMZh-YkybNXja9tICDCArHKzDcPEmlUw&lib=MC6W16NMAh2ej26ekIPfxlrSTbnvLL5dA';

export const fetchGuideContacts = createAsyncThunk(
  'guideContacts/fetchGuideContacts',
  async () => {
    const response = await axios.get(API_URL);
    return response.data;
  }
);

const guideContactSlice = createSlice({
  name: 'guideContacts',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGuideContacts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchGuideContacts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchGuideContacts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default guideContactSlice.reducer;
